angular.module('shared').directive('toggleTableFiltersButton', function() {
  return {
    restrict: 'E',
    scope: {
      open: '=',
      toggle: '&',
      toggleModal: '&'
    },
    template: require('templates/shared/toggle_table_filters_button.html.slim'),
    controller: ["$scope", function($scope) {
      return $scope.onClick = function() {
        if (window.innerWidth > 991) {
          return $scope.toggle();
        } else {
          return $scope.toggleModal();
        }
      };
    }]
  };
});
